import { CIcon } from '~/icons/types'

export const ciSaleRequest: CIcon = {
  width: 18,
  height: 16,
  paths: [
    {
      d:
        'M8.285 15.688c0 .16-.114.312-.284.312H.31c-.14 0-.233-.054-.28-.161a.841.841 0 0 1-.03-.285V3.607c0-.064.072-.147.129-.197L3.902.116c.162-.141.298-.16.46-.018 1.284 1.118 2.566 2.238 3.847 3.36.049.041.073.108.073.199.003 4.01.004 8.021.003 12.031ZM5.27 3.816a1.13 1.13 0 0 0-1.127-1.128 1.127 1.127 0 0 0-1.128 1.128 1.13 1.13 0 0 0 1.128 1.129A1.127 1.127 0 0 0 5.27 3.816Zm5.457-.145c1.95.033 3.53 1.407 4.022 3.247a.023.023 0 0 1-.021.029H9.026C9.009 6.947 9 6.938 9 6.92V3.695c0-.014.007-.022.022-.022.893-.005 1.462-.005 1.705-.002Zm4.301 4.022c1.222.346 2.126 1.311 2.367 2.553.04.206.06.522.06.948v2.834c0 .321-.236.368-.515.368H9.02a.022.022 0 0 1-.02-.022V7.682c0-.019.01-.028.028-.028 1.902-.004 3.803-.004 5.703 0 .108 0 .207.013.297.039Zm.676 3.502a1.672 1.672 0 1 0-3.344 0 1.672 1.672 0 0 0 3.344 0ZM16.73 15.1c.006 0 .013.002.018.007a.027.027 0 0 1 .008.02v.143c0 .19-.077.372-.214.506a.742.742 0 0 1-.518.209h-2.745a.742.742 0 0 1-.518-.21.705.705 0 0 1-.214-.505v-.144a.027.027 0 0 1 .027-.027h4.155Z',
      fill: 'currentColor'
    },
    {
      d:
        'M4.314 13.905c-.697 0-1.241-.247-1.632-.742-.39-.495-.586-1.208-.586-2.139 0-.931.195-1.644.586-2.139.39-.495.935-.742 1.632-.742.464 0 .85.11 1.156.327.312.213.555.511.729.894l-.515.32a1.497 1.497 0 0 0-.515-.687c-.232-.176-.517-.263-.855-.263-.418 0-.755.125-1.014.375s-.42.582-.483.997h2.035v.535H2.785v.766h2.067v.535H2.817c.068.415.23.747.483.997.259.25.596.375 1.014.375.348 0 .641-.093.879-.279.238-.186.414-.43.53-.734l.516.343c-.085.18-.185.348-.301.503a1.838 1.838 0 0 1-.412.399c-.154.112-.33.2-.531.263-.2.064-.428.096-.681.096Z',
      fill: '#fff'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'sale-request',
  type: 'solid'
}
